export default function ArrowLeft() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.879 17.2929C11.2695 17.6834 11.2695 18.3166 10.879 18.7071C10.4885 19.0976 9.85529 19.0976 9.46477 18.7071L4.87898 14.1213C3.70741 12.9497 3.70741 11.0503 4.87898 9.87868L9.46477 5.29289C9.85529 4.90237 10.4885 4.90237 10.879 5.29289C11.2695 5.68342 11.2695 6.31658 10.879 6.70711L6.58609 11H19.1719C19.7242 11 20.1719 11.4477 20.1719 12C20.1719 12.5523 19.7242 13 19.1719 13H6.58609L10.879 17.2929Z"
				fill="#E20074"
			/>
		</svg>
	);
}
